import Urls from "../../api/endpoints";
import Table from "react-bootstrap/Table";
import { Row, Col } from "react-bootstrap";
import Headings from "../../constants/headings";
import Constants from "../../constants/constants";
import React, { useState, useEffect } from "react";
import { NotLogin, Loading } from "../../shared/index";
import { Pdf } from "../../assets/images/svg/icon"
import {
  CommaSeparator,
  getBankGatewayStateClass,
  getBankGatewayStateText,
  ErrorHandling,
  ToPersianNumber,
  DateToPersianNumber,
  mapGatewayName,
} from "../../functions/index";
import InvoiceOfUser from "../invoiceList/invoiceOfUser";

function Transactions(props) {
  const [data, setData] = useState(null);
  const [credit, setCredit] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {

    fetch(Urls.getSearchedUserInvoiceHistoryById(props.userId), {
      method: "Get",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + props.token,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        setLoading(false);
        data.sort(function (a, b) {
          return new Date(b.LogDate) - new Date(a.LogDate);
        });
        setData(data);
      })
      .catch((error) => {
        ErrorHandling(error, "transaction get error", setLoading);
      });

    fetch(Urls.getCustomerCredit(props.userId), {
      method: "Get",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + props.token,
      },
    })
      .then((response) => response.json())
      .then((d) => {
        setCredit(d);
      })
      .catch((error) => {
        ErrorHandling(error, "customer's credit get error", setLoading);
      });
  }, [props.userId, props.token]);


  const downloadFactoeUser = (type, index) => {
    let temp = [...data]
    temp.map((item, itemIndex) => {
      if (itemIndex === index) {
        item.isLoading = type
      }
    })
    setData(temp)
  }

  return (
    <main>
      {!props.login ? (
        <NotLogin></NotLogin>
      ) : loading ? (
        <Loading></Loading>
      ) : (
        <>
          <div className="top-margin"></div>
          <div className="user-info-container user-service-container" style={{ position: 'relative !important' }}>
            <div className="user-info">
              <h1>{Headings.TransactionTitle000}</h1>
              <div className="divider"></div>
              <Row className="row-reverse">
                <div className="credit-container">
                  <span>
                    {Constants.Credit}:{" "}
                    {credit && ToPersianNumber(CommaSeparator(credit))}
                    <span className={credit >= 0 ? "hide" : ""}>-</span>{" "}
                    {Constants.Currency}
                  </span>
                </div>
              </Row>
              <div className='table-context'>
                <Table className='table table-bordered  invoice-table'>
                  <thead>
                    <tr>
                      {Headings.TransactionHeader.map((h, index) => (
                        <th key={index}>{h}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {data &&
                      data.map((d, index) => (
                        <tr key={index}>
                          <td>
                            {d.PersianIssueDate &&
                              DateToPersianNumber(d.PersianIssueDate)}
                          </td>
                          <td>
                            {d.PersianLogDate &&
                              DateToPersianNumber(d.PersianLogDate)}
                          </td>
                          <td className="pay-desc">
                            {d.InvoiceItemDescription}
                            {/* {d.GatewayDescription && (
                                <span>
                                  &nbsp;
                                  {Constants.AuthHistoryArray.open}
                                  {d.GatewayDescription}
                                  {Constants.AuthHistoryArray.close}
                                </span>
                              )} */}
                          </td>
                          <td
                            className={getBankGatewayStateClass(
                              d.GatewayState
                            )}
                          >
                            {getBankGatewayStateText(d.GatewayState)}
                          </td>
                          <td>{mapGatewayName(d.GatewayName)}</td>
                          <td>{d.DiscountCode}</td>
                          <td>
                            {ToPersianNumber(CommaSeparator(d.Subtotal))}{" "}
                            {Constants.Currency}
                          </td>
                          <td>
                            {ToPersianNumber(CommaSeparator(d.TotalDiscount))}{" "}
                            {Constants.Currency}
                          </td>
                          <td>
                            {ToPersianNumber(CommaSeparator(d.VAT))}{" "}
                            {Constants.Currency}
                          </td>
                          <td>
                            {ToPersianNumber(CommaSeparator(d.PayableAmount))}{" "}
                            {Constants.Currency}
                          </td>
                          {d.FactorConfirmed === true && d.GatewayState===2 &&  parseInt(d?.PersianIssueDate.split('/')[0]) >= parseInt(1402) && d.MoadianStatus==="SUCCESS" &&
                            <div className="d-flex flex-row justify-content-between">
                              <td onClick={() => downloadFactoeUser(true)}>
                                {!d.isLoading && <span onClick={() => downloadFactoeUser(true, index)}><Pdf /></span>}
                                {d.isLoading && <div className='table-context-invoice'>
                                  <div className='table-loading-invoice'>
                                    <div className="spinner-border" role="status" aria-hidden="true"></div>
                                  </div>
                                </div>}
                                {d.isLoading && <InvoiceOfUser itemOfTable={d} setShowPdf={() => downloadFactoeUser(false, index)} />}
                              </td>
                            </div>
                          }
                        </tr>
                      ))}
                  </tbody>
                </Table>
              </div>
            </div>
            {/* <Paging></Paging> */}
          </div>
        </>
      )}
    </main>
  );
}
export default Transactions
